import { ExportButton } from "./ExportButton";

interface Props {
	handleExportToPdf: () => void;
	disabled?: boolean;
	loading?: boolean;
}

export const PdfButton = ({ handleExportToPdf, disabled, loading }: Props) => (
	<ExportButton
		label="EXPORT PDF"
		icon="far fa-file-pdf"
		color="#C62828"
		onClick={handleExportToPdf}
		disabled={disabled}
		loading={loading}
	/>
);
